export default {"src":"/_next/static/media/maven-logo.7827bf46.svg","height":13,"width":152,"blurWidth":0,"blurHeight":0};